module.exports = __webpack_public_path__ + "static/img/address_lp.7b4457f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/address_lp.png
// module id = JlQP
// module chunks = 29